<ng-container [formGroup]="group">
  <div class="d-flex flex-row align-items-center">
    <a
      class="text-success d-flex align-items-center justify-content-center button-slider border border-success text-center rounded-circle"
      (click)="changeSlider(-(model.step || 1))"
    >
      <div>&minus;</div></a
    >
    <div class="px-2">{{ model.min }}</div>
    <div class="flex-fill">
      <nouislider
        #nouiSlider
        class="slider slider-success"
        [step]="model.step"
        [min]="model.min"
        [max]="model.max"
        [disabled]="model.disabled"
        [formControlName]="model.id"
        [config]="config"
        (change)="onChange($event)"
        (update)="onCustomEvent($event, 'update')"
        (slide)="onCustomEvent($event, 'slide')"
        (set)="onCustomEvent($event, 'set')"
        (start)="onCustomEvent($event, 'start')"
        (end)="onCustomEvent($event, 'end')"
      ></nouislider>
    </div>
    <div class="px-2">{{ model.max }}</div>
    <a
      class="text-success d-flex align-items-center justify-content-center button-slider border border-success text-center rounded-circle"
      (click)="changeSlider(model.step)"
    >
      <div>&plus;</div>
    </a>
  </div>
</ng-container>
